export default __webpack_public_path__ + "static/news_376-c572572f64f9331fb79e250dcfc47adc.jpg";